import Vue from 'vue';
import {
  TimePicker,
  Row,
  Col,
  Form,
  Input,
  Icon,
  Button,
  Divider,
  notification,
  message,
  Popover,
  Layout,
  Menu,
  Breadcrumb,
  Dropdown,
  Avatar,
  Upload,
  Table,
  Tabs,
  Tag,
  Modal,
  Popconfirm,
  Drawer,
  LocaleProvider,
  ConfigProvider,
  Badge,
  Checkbox,
  DatePicker,
  Pagination,
  Radio,
  Select,
  Alert,
  Empty,
  InputNumber,
  Tooltip,
  TreeSelect,
  Spin,
  Card,
  List,
  Tree,
  Switch,
  Skeleton,
  FormModel,
  Collapse,
  Steps,
  Cascader,
  Calendar,
  Progress,
  Transfer,
  PageHeader,
  Timeline,
  AutoComplete,
  Descriptions,
} from 'ant-design-vue';

Vue.use(Steps);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(Input);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Divider);
Vue.use(Popover);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Breadcrumb);
Vue.use(Dropdown);
Vue.use(Avatar);
Vue.use(Upload);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Modal);
Vue.use(Popconfirm);
Vue.use(Drawer);
Vue.use(LocaleProvider);
Vue.use(ConfigProvider);
Vue.use(Badge);
Vue.use(Checkbox);
Vue.use(DatePicker);
Vue.use(Pagination);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Alert);
Vue.use(Empty);
Vue.use(InputNumber);
Vue.use(Tooltip);
Vue.use(TreeSelect);
Vue.use(Spin);
Vue.use(Card);
Vue.use(List);
Vue.use(Tree);
Vue.use(Skeleton);
Vue.use(Switch);
Vue.use(FormModel);
Vue.use(Collapse);
Vue.use(TimePicker);
Vue.use(Cascader);
Vue.use(Calendar);
Vue.use(Progress);
Vue.use(Transfer);
Vue.use(PageHeader)
Vue.use(Timeline)
Vue.use(AutoComplete)
Vue.use(Descriptions)

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;
